export default __webpack_public_path__ + "static/media/12.59145158.jpg";